@use '@lib/assets/styles/main' as *;

.filterWrap {
  padding-bottom: 16px;
}

.filterRow {
  display: flex;
  align-items: center;
  & > div {
    padding: 0 4px;
    &.clearBtnCol {
      padding-left: 0;
    }
  }
}

.filter {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 16px;
  align-items: center;
  justify-content: space-between;
}

.viewChangeActions {
  display: flex;
  gap: 8px;
}
